import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { userStatsQueryKeys } from '@/domains/user/api/user-stats';

export const useCaseResolvingStatsQuery = () => {
  const initialDate = useMemo(() => +dayjs().subtract(6, 'day').startOf('day').toDate(), []);
  const { data = [], isLoading } = useQuery({
    ...userStatsQueryKeys.userDailyCasesResolvedStats({ fromDate: initialDate }),
    // @ts-ignore
    enabled: Boolean(initialDate),
  });

  return {
    data,
    isLoading,
  };
};
